import { render, staticRenderFns } from "./LegalDutyAnotherPersonFSSurvey.vue?vue&type=template&id=942e15d4"
import script from "./LegalDutyAnotherPersonFSSurvey.vue?vue&type=script&lang=ts"
export * from "./LegalDutyAnotherPersonFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports